import { render, staticRenderFns } from "./synthese-alertes.vue?vue&type=template&id=67f910b4&scoped=true&"
import script from "./synthese-alertes.vue?vue&type=script&lang=ts&"
export * from "./synthese-alertes.vue?vue&type=script&lang=ts&"
import style0 from "./synthese-alertes.vue?vue&type=style&index=0&id=67f910b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f910b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAvatar,VBtn,VCard,VIcon,VSpacer,VSwitch})
